module.exports = __webpack_public_path__ + "31a1f3c3846e30f4e6f50b7013520ba8.png";